import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { projectKeys } from './project.key';
import { useState } from 'react';

export function useGetClientProjects(
  clientId: string,
  take?: number,
  skip?: number
) {
  const getApi = useApi();
  const [count, setCount] = useState(0);

  const query = useQuery({
    queryKey: projectKeys.findAllForClient(clientId, take, skip),
    queryFn: async () => {
      const api = await getApi();
      const res = await api.projectsFindClientProjects(clientId, take, skip);
      setCount(Number(res.headers['x-total-count'] ?? res.data.length));
      return res.data;
    },
    enabled: Boolean(clientId),
    keepPreviousData: true,
  });

  return {
    ...query,
    count,
  };
}
